import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export const HelpPage: React.FC = () => {
    // scroll to top:
    window.scrollTo(0, 0);

    // set document title:
    document.title = "Help | ipwd.club";
    
    return (
        <div style={{textAlign: "center", maxWidth: "800px"}}>
            <h1>Help</h1>
            <h2>File Access</h2>
            <Accordion>
                <AccordionSummary>
                    <h4>🔗 How do I link my Patreon account?</h4>
                </AccordionSummary>
                <AccordionDetails style={{backgroundColor: "#131313", textAlign: "left"}}>
                    <p>
                        To link your Patreon account, go to your <Link to="/profile">Profile Page</Link> and click the "Link Patreon Account" button. You will be redirected to Patreon to authorize the connection. Once authorized, you will be redirected back to our site and your account will be linked.
                    </p>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary>
                    <h4>❔ Troubleshooting File Access Issues</h4>
                </AccordionSummary>
                <AccordionDetails style={{backgroundColor: "#131313", textAlign: "left"}}>
                    <ul>
                        <li>If you have multiple Patreon accounts, ensure you linked the correct one to your ipwd.club account.</li>
                        <li>Make sure your Patreon membership is active and at the required tier to access the files, and that your payment wasn't declined or pending.</li>
                        <li>Try logging out and logging back in to refresh your session.</li>
                        <li>Clear your browser cache and cookies, then try again.</li>
                    </ul>
                    <p>
                        If the issue persists, please contact us on <a href="https://www.patreon.com/iplaywithdolls" target="_blank" rel="noreferrer">Patreon</a> or message us on the Discord server.
                    </p>
                </AccordionDetails>
            </Accordion>
            <br />
            <h2>Video Playback</h2>
            <Accordion>
                <AccordionSummary>
                    <h4>❓ What is "Flatscreen" and "VR"?</h4>
                </AccordionSummary>
                <AccordionDetails style={{backgroundColor: "#131313", textAlign: "left"}}>
                <p>
                    <b>Flatscreen</b> refers to traditional 2D videos that you can watch on your computer, TV, smartphone, tablet, etc.
                </p>
                <p>
                    <b>VR</b> refers to immersive Virtual Reality videos that you can watch with a VR headset. SBS (side-by-side) is the technology used to create these videos.
                </p>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary>
                    <h4>📺 Playing Flatscreen Videos</h4>
                </AccordionSummary>
                <AccordionDetails style={{backgroundColor: "#131313", textAlign: "left"}}>
                    <p>
                        You can stream flatscreen videos here on the website, or download them and watch them on your device. We recommend downloading the 4K version of the video if your device supports it, as it will provide the best quality.
                    </p>
                    <p>
                        For playing flatscreen videos, we highly recommend <a href="https://www.videolan.org/" rel="noreferrer" target="_blank">VLC Media Player</a>. VLC is a free and open-source media player. It is available for Windows, macOS, Linux, Android, and iOS. It also supports playlists, so you can queue up multiple videos to play in a row. Simply go to <b>View &gt; Playlist</b> (on desktop) to set up a playlist.
                    </p>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary>
                    <h4>🥽 Playing VR Videos</h4>
                </AccordionSummary>
                <AccordionDetails style={{backgroundColor: "#131313", textAlign: "left"}}>
                    <p>
                        Firstly, to play VR videos you need a VR headset. Common options are:
                    </p>
                    <ul>
                        <li><a href="https://www.meta.com/quest/" rel="noreferrer" target="_blank">Meta Quest</a></li>
                        <li><a href="https://www.valvesoftware.com/en/index" target="_blank" rel="noreferrer">Valve Index</a></li>
                        <li><a href="https://www.vive.com/" target="_blank" rel="noreferrer">HTC Vive</a></li>
                    </ul>
                    <h2>Heresphere</h2>
                    <p>
                        <b>Heresphere</b> is the video player we recommend for optimal viewing. There is a free version and a demo. The demo just has an occasional 15 second delay when using the menu.
                    </p>
                    <ul>
                        <li><a href="https://www.meta.com/en-gb/experiences/heresphere-vr-video-player/6308914842477595" target="_blank" rel="noreferrer">Heresphere for Meta Quest</a></li>
                        <li><a href="https://store.steampowered.com/app/1234730/HereSphere_VR_Video_Player/" target="_blank" rel="noreferrer">Heresphere on Steam</a></li>
                    </ul>
                    <p>
                        Simply transfer the video onto your device, then open it in Heresphere.
                    </p>
                    <p>
                        We recommend the following settings:
                    </p>
                    <ul>
                        <li>Stereo: <b>Side-by-Side</b> (SBS)</li>
                        <li>Aspect Ratio: <b>High-definition</b></li>
                        <li>Adjust the pitch, distance and other settings to your comfort.</li>
                        <li><b>Lock your settings</b> (the lock icon near the Main Menu button) to prevent settings being reset for each new video (you will still need to set the stereo and aspect ratio, though.)</li>
                    </ul>
                    <p>
                        <img src="https://ipwd-public.b-cdn.net/heresphere%20settings.png" alt="VR Settings" style={{maxWidth: "100%"}} />
                    </p>
                    <h2>Other VR Players</h2>
                    <p>
                        If you don't like Heresphere or it's not available on your headset, other options we recommend include:
                    </p>
                    <ul>
                        <li><a href="https://deovr.com/app" target="_blank" rel="noreferrer">DeoVR</a></li>
                        <li><a href="https://skybox.xyz/" target="_blank" rel="noreferrer">Skybox</a></li>
                        <li><a href="https://4xvr.net/" target="_blank" rel="noreferrer">4XVR</a></li>
                    </ul>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}